module.exports = __webpack_public_path__ + "img/personal-web07.2dfeda3b.png";